import React, { useEffect, useState, useCallback } from "react"
import { useParams, useSearchParams, useResolvedPath, Outlet, useNavigate } from "react-router-dom"
import { useAppCtx, appStore } from "lib/state"
import { UnitTitleBlock } from "lib/components"
import { ELEMENTS, queryTools, cn } from "lib/utils"
import { DisputeList, DisputePreview } from "."

export default function DisputeWrapper({ children }:any){
  const navigate = useNavigate()
  const { dspid, tab } = useParams()
  const { pathname } = useResolvedPath("")
  const [ searchParams, setSearchParams ] = useSearchParams()

  const [ showPreview, setShowPreview ] = useState(false)
  const [ selectedElement, setSelectedElement ] = React.useState<any>()

  const { data:_Dispute } = queryTools.resource.parseQueryForApi("dispute.findById", { id: dspid }, { enabled: !!dspid })

  const tabs = [
    { id: "setup", label: "Setup", visible: true, selected: false, clickFn: (dspid:string) => navigate(`/dispute/${dspid}/setup`) },
    { id: "config", label: "Config", visible: true, selected: false, clickFn: (dspid:string) => navigate(`/dispute/${dspid}/config`) },
    { id: "preview", label: "Preview", visible: true, selected: false, clickFn: (dspid:string) => navigate(`/dispute/${dspid}/preview`) },
    { id: "element", label: `Element: ${selectedElement}`, visible: false, selected: false, clickFn: null },
  ]
  
  const { appState } = useAppCtx()
  const { store, AppStore }:any = appStore()
  const { update } = AppStore

  const [ tabset, setTabset ] = useState<any>(tabs)
  
  const selectTab = (tab:string) => setTabset((prev:any) => prev.map((t:any) => {
    setShowPreview(false)
    if( t.id === tab.toLowerCase() ){
      return { ...t, selected: true, visible: true }
    } else {
      return { ...t, selected: false, visible: t.id !== "element" }
    }
  }))

  const selectElement = (elem:any) => {
    setSelectedElement(elem)
  }

  const getTitle = () => {
    if( _Dispute === undefined ){
      return "Manage Disputes"
    } else {
      let title = `Manage Dispute: ${_Dispute?.title}`
      if( _Dispute.Id !== undefined && _Dispute.Id != "0" ){
        title += ` (ID: ${_Dispute.Id})`
      }
      return title
    }
  }

  useEffect(() => {
    const tab = window.location.href.split("/").pop()?.split("?")[0]
    if( tab ){
      selectTab(tab)
    }
  },[window.location.href])

  useEffect(() => {
    if( searchParams.get("elem") ){
      const elemTitle = ELEMENTS.find((el:any) => el.refstr === searchParams.get("elem"))?.title 
      if( elemTitle ){
        setTabset((prev:any) => prev.map((t:any) => {
          if( t.id === "element" ){
            return { ...t, label: `Element: ${elemTitle}`, visible: true, selected: true }
          } else {
            return { ...t, selected: false, visible: true }
          }
        }))
      }
    }
  },[searchParams.get("elem")])

  useEffect(() => {
    if( selectedElement !== undefined ){
      navigate(`/dispute/${dspid}/element?elem=${selectedElement}`)
    }
  },[selectedElement])
  
  return (
    <div className="w-full h-full flex flex-col justify-start items-start pt-6">
      <UnitTitleBlock title={getTitle()}>
        <span className="text-sm uppercase cursor-pointer" onClick={() => navigate("/dispute")}>back to list</span>
      </UnitTitleBlock>

      <div className="w-full">
        { dspid === undefined && <DisputeList /> }
        { dspid !== undefined && (
          <div className="w-full flex flex-col px-2">
            <div className="w-full flex justify-start items-center border-b border-solid border-slate-700">
              { tabset.filter((t:any) => t.visible).map((tab:any, i:number) => (
                <div 
                  key={i} 
                  onClick={() => tab.clickFn(dspid)}
                  className={cn(
                    "relative top-[1px] flex justify-start items-center gap-2 border border-solid border-slate-700 rounded-b-none pl-3 pr-4 py-1 first:rounded-tl-md first:rounded-r-none last:rounded-tr-md cursor-pointer hover:bg-teal-900/20 uppercase text-sm tracking-wider border-b-transparent",
                    tab.selected === true ? "text-yellow-500 border-b-2 border-b-solid border-b-slate-900" : "bg-transparent"
                  )}
                >
                  <span>{ tab.label }</span>
                </div>
              ))}
            </div>

            <div className="w-full">
              <Outlet />
            </div>
          </div>
        )}
      </div>
    </div>
  )
}